import { atom, useAtom } from 'jotai';
export const conversionCountAtom = atom(0);
export const useConversionCount = () => {
    return useAtom(conversionCountAtom);
};
